import { useAtomValue } from 'jotai'
import { phasesAtom } from '../atoms/reviewPricing.atoms'

export const useIsFirstPhase = (phaseId: string) => {
  const phases = useAtomValue(phasesAtom)
  return phases[0]?.id === phaseId
}
